import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 登入身分列（取代舊的 `ApiTokenBar`）。
 *
 * console 的認證只有一套：PIN 登入簽發的 Bearer session（DECISIONS 0049）。寫入類請求跟讀取類
 * 一樣帶 `Authorization: Bearer`，所以**不再需要貼任何 token**；這一列只做兩件事：
 * 1. 平常顯示目前登入者（email／role），讓使用者知道「現在是誰在操作」。
 * 2. `/api/*` 回 401（session 過期／被撤銷）時，換成一句「登入已經過期，請重新登入」
 *    ＋一顆「重新登入」按鈕（由宿主傳 `onRelogin` 導回登入頁）。
 *
 * 「過期」狀態只存在這個元件：重新登入後 `AuthGate` 會換掉 children，元件重掛就自動清掉。
 */
import { useEffect, useState } from 'react';
import { onSessionExpired } from '../api/client';
function roleLabel(roles) {
    if (roles.length === 0)
        return '唯讀';
    return roles.includes('admin') ? 'admin' : roles.join('／');
}
export function SessionBar({ email = '', roles = [], onRelogin }) {
    const [expiredNotice, setExpiredNotice] = useState(null);
    // 訂閱一次即可：`http-client` 只在 401 時發這個通知，不輪詢。
    useEffect(() => onSessionExpired((message) => setExpiredNotice(message)), []);
    if (expiredNotice !== null) {
        return (_jsxs("div", { className: "flex flex-wrap items-center gap-x-2 gap-y-1.5 px-2", "data-testid": "session-expired-bar", children: [_jsx("span", { className: "text-[11px] leading-tight", style: { color: 'var(--ak-color-danger)' }, role: "alert", "data-testid": "session-expired-notice", children: expiredNotice }), onRelogin === undefined ? null : (_jsx("button", { type: "button", className: "cui-btn cui-btn--sm cui-btn--primary", onClick: onRelogin, "data-testid": "session-relogin", children: "\u91CD\u65B0\u767B\u5165" }))] }));
    }
    if (email === '')
        return null;
    return (_jsxs("div", { className: "flex items-center justify-end gap-2 px-2 text-[11px] leading-tight", style: { color: 'var(--ak-color-text-tertiary)' }, "data-testid": "session-bar", children: [_jsx("span", { className: "max-w-[16rem] truncate", title: email, "data-testid": "session-email", children: email }), _jsx("span", { className: "rounded-full bg-white/10 px-2 py-0.5 font-mono", "data-testid": "session-role", children: roleLabel(roles) })] }));
}
//# sourceMappingURL=SessionBar.js.map